import Grid from '@mui/material/Grid'
import ResearchCard from './ResearchCard'
import type { ResearchEntry } from './ResearchCard'
import EmptyState from '../common/EmptyState'

interface ResearchListProps {
  entries: ResearchEntry[]
}

export default function ResearchList({ entries }: ResearchListProps) {
  if (entries.length === 0) {
    return (
      <EmptyState
        heading="No research found"
        body="Try adjusting your search terms or selecting a different theme."
      />
    )
  }

  return (
    <Grid container spacing={3}>
      {entries.map((entry) => (
        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={entry.id}>
          <ResearchCard entry={entry} />
        </Grid>
      ))}
    </Grid>
  )
}
